(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/*

@package purnatur


*/
document.addEventListener('DOMContentLoaded', function (e) {
  var dropdown = document.querySelector('.dropdown');
  var menu_link = dropdown.querySelector('a');
  menu_link.addEventListener("touchstart", function (e) {
    if (menu_link !== e.target) {
      console.log(e.target);
    }

    e.preventDefault();
    var child = dropdown.querySelector('.dropdown-menu');

    if (child.style.display == 'block') {
      child.style.display = "none";
    } else {
      child.style.display = "block";
    }
  }); //******************************************** */
  // ACTION ON DISCOVER HEADER ARROW
  //*********************************************** */ 		

  var arrow = document.getElementById('decouvrir-arrow');

  if (arrow) {
    arrow.addEventListener('click', function (e) {
      e.preventDefault();
      var section = document.getElementById('home-section-2');
      section.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      });
    });
  }

  $('.two-col-hover .background-image').mouseover(function () {
    var bg = $(this);
    var color = bg.data('color');
    var dataurl = bg.data('url');
    console.log(dataurl);
    bg.css('background-image', 'url(' + dataurl + ')');
  });
  $('.two-col-hover .background-image').mouseout(function () {
    var bg = $(this);
    var color = bg.data('color');
    var dataurl = bg.data('url');
    bg.css('background-image', 'linear-gradient(180deg, ' + color + ', ' + color + '), url(' + dataurl + ')');
  });
  $('.two-col-hover .background-image').click(function () {
    window.location.replace($(this).data('link'));
  });
  jQuery('#carouselProducts').carousel('pause');
  $('.carousel').on('slid.bs.carousel', function () {
    var indicatorsAct = $(".carousel-mobile li.active").data("slide-to");
    $(".carousel-desktop li").removeClass("active");
    $(".carousel-desktop").find("[data-slide-to='" + indicatorsAct + "']").addClass("active");
  });
  $('ol.carousel-mobile li').on("click", function () {
    $('ol.carousel-mobile li.active').removeClass("active");
    $("ol.carousel-desktop li.active").removeClass("active");
    $(this).addClass("active");
    var indicators = $(this).data("slide-to");
    $(".carousel-desktop").find("[data-slide-to='" + indicators + "']").addClass("active");
  });
  var inputs = document.querySelectorAll('.inputfile');
  Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling,
        labelVal = label.innerHTML;
    input.addEventListener('change', function (e) {
      var fileName = '';

      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      } else {
        fileName = e.target.value.split("\\").pop();
      }

      if (fileName) {
        label.querySelector('span').innerHTML = fileName;
      } else {
        label.innerHTML = labelVal;
      }
    });
  });
  var recipeForm = document.getElementById('recipe_submit_form');

  if (recipeForm != null) {
    recipeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      resetMessages(); // collect all datas

      var data = {
        username: recipeForm.querySelector('[name = "username"]').value,
        title: recipeForm.querySelector('[name = "title"]').value,
        url: recipeForm.querySelector('[name = "url"]').value,
        description: recipeForm.querySelector('[name = "description"]').value,
        nonce: recipeForm.querySelector('[name = "nonce"]').value
      }; // validation everything

      if (!data.username) {
        recipeForm.querySelector('[data-error="invalidUserName"]').classList.add('show');
        return;
      }

      if (!data.title) {
        recipeForm.querySelector('[data-error="invalidTitle"]').classList.add('show');
        return;
      }

      if (!data.description) {
        recipeForm.querySelector('[data-error="invalidDescription"]').classList.add('show');
        return;
      } // ajax


      recipeForm.querySelector('.js-form-submission').classList.add('show');
      var formData = new FormData(recipeForm); //let params = new URLSearchParams(new FormData(recipeForm));

      var url = recipeForm.dataset.url;
      fetch(url, {
        method: 'POST',
        body: formData
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        resetMessages();
        recipeForm.querySelector('.js-form-error').classList.add('show');
      }).then(function (response) {
        resetMessages(); //deal with the response

        if (response === 0 || response == 'error') {
          recipeForm.querySelector('.js-form-error').classList.add('show');
          return;
        }

        recipeForm.querySelector('.js-form-success').classList.add('show');
        recipeForm.reset();
      });
    });
  }

  var job_form = document.getElementById('recipe_submit_form');
});

function resetMessages() {
  document.querySelectorAll('.field-msg').forEach(function (f) {
    return f.classList.remove('show');
  });
}

function validateURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(str);
}

function validateFile() {
  var valid = true;
  var file_name = "";
  var file_type = "";
  var file_size = "";
  var error_msg = "";
  var valid_size = 3 * 1000 * 1000;
  var display_error = document.getElementById('file_error');
  var file = document.getElementById("file_recipe");

  if (file.files.length != 0) {
    file_name = file.files[0].name;
    file_size = file.files[0].size;
    file_type = file.files[0].type;

    if (file_type != "image/png" && file_type != "image/jpeg" && file_type != "application/pdf") {
      valid = false;
      error_msg = error_msg + "\n* Only 'PNG', 'JPG/JPEG' and 'PDF' file type supported.";
    }

    if (file_size > valid_size) {
      valid = false;
      error_msg = error_msg + "\n* Filesize should be upto 3MB.";
    }
  } else {
    valid = false;
    error_msg = error_msg + "\n* Please select any image file.";
  }

  if (valid == true) {
    //alert("File pass all validation. Now it is ready to send.");

    /*Write ajax code here to send file to the server.*/
    return true;
  } else {
    //display_error.innerHTML = error_msg;
    return false;
  }
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
} // When the user scrolls the page, execute myFunction


window.onscroll = function () {
  makeSticky();
}; // Get the header


var navbar = document.getElementById("main-navigation"); // Get the offset position of the navbar

var sticky = navbar.offsetTop; // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position

function makeSticky() {
  if (window.pageYOffset > sticky) {
    navbar.classList.add("sticky");
  } else {
    navbar.classList.remove("sticky");
  }
}

},{}]},{},[1]);
